<template>
  <div id="tab4" class="mt-n4">
    <div>
      <SectionTitle
        icon="fas fa-file-user"
        content="Evaluación / Servicios"
        container-class="tag-badge-main-info"
      />
      <SectionTitle
        :has-line="true"
        content="Evaluaciones administradas previamente"
      />
    </div>

    <div>
      <div class="row header thead-property d-flex align-items-center p-3 mx-0">
        <div class="col-md-5 pt-0">
          <span>Evaluación</span>
        </div>
        <div class="col-md-2 pt-0">
          <span>Fecha</span>
        </div>
        <div class="col-md-3 pt-0">
          <span>Administrado Por</span>
        </div>
      </div>
    </div>

    <!--SIN Evaluaciones-->
    <div v-if="previouslyAdministeredEvaluations.length == 0">
      <div class="mb-4 p-4 info-seguimiento">
        <div class="col-12 text-center">
          <button
            id="btnFA"
            class="btn bg-light-white w-75 pt-1"
            :disabled="
              isAddEvaluationBtnDisabled
            "
            @click="goToAddEvaluation()"
          >
            <i class="fas fa-file-plus pr-4 text-green" />
            <span class="text-button-add-document">
              Presione aquí para añadir evaluaciones administradas previamente
            </span>
          </button>
        </div>
      </div>
    </div>

    <!--Con evaluaciones-->
    <div v-if="previouslyAdministeredEvaluations.length > 0">
      <Accordion id="accordionPrevioslyEvaluations">
        <AccordionItem
          v-for="(evaluation, index) in previouslyAdministeredEvaluations"
          :id="'accordionItemEvaluation' + index"
          :key="evaluation.studentEvaluationId"
          :title="evaluation.disciplineTypeName"
          :title-style="'col-md-5 col-sm-12 pt-0 ml-n4'"
          :content-style="'col-md-7 col-sm-12 mt-3 pl-0'"
          :expanded="false"
          class="custom-accordion-item"
        >
          <div slot="header-content">
            <div class="row">
              <div class="col-md-4 col-sm-12">
                <span>{{ evaluation.evaluationDate }}</span>
              </div>
              <div class="col-md-4 col-sm-12 left">
                <span>{{ evaluation.evaluationAdministeredBy }}</span>
              </div>
              <div class="col-md-4 col-sm-12 text-right mt-n1 col-actions">
                <div class="dropdown">
                  <button
                    :id="'ddEvaluation' + index"
                    class="btn btn-dropdown-actions dropdown-toggle pt-1"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Acciones
                  </button>
                  <div
                    class="dropdown-menu dropdown-menu-right"
                    aria-labelledby="ddEvaluationEdit"
                  >
                    <div
                      v-if="!(isReadMode && studentStatus != 'Registro')"
                      class="dropdown-item"
                      @click="deleteEvaluation(evaluation)"
                    >
                      <em class="fa fa-times-circle text-red pr-1" />
                      <span>Eliminar Evaluación</span>
                    </div>
                    <div
                      class="dropdown-item"
                      @click="downloadEvaluation(evaluation)"
                    >
                      <em class="fa fa-file-download text-green pr-1" />
                      <span>Documento Evaluación</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div slot="content">
            <div class="col-12 row mt-3">
              <div class="col-md-12 pl-4 pr-0 mr-1 ml-4 pt-0 ">
                <span><b>Comentario:</b></span>
                <p>{{ evaluation.evaluationDescription }}</p>
              </div>
            </div>
          </div>
        </AccordionItem>
      </Accordion>
      <div class="text-right mt-4 pr-1">
        <action-button
          v-if="canAddEvaluation"
          variant="success pl-4 pr-4"
          type="submit"
          i="fas fa-file-plus"
          :disabled="isAddEvaluationBtnDisabled"
          @click="goToAddEvaluation()"
        >
          Añadir
        </action-button>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col">
        <SectionTitle
          content="Servicios de Otras Agencias"
          :has-line="true"
          class="mr-4"
        />
        <OtherAgencyService
          :disabled="
            (isReadMode && studentStatus != 'Registro') || !canEditTab4
          "
        />
      </div>
    </div>
    <FixedBottomSaveButton v-if="isPreRegistred" :offset="200" @click="save" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapGetters } = createNamespacedHelpers('$_student');
import { SectionTitle } from '@/components/pei/shared';
import FixedBottomSaveButton from '@/components/common/FixedBottomSaveButton';
import { Accordion, AccordionItem } from '@/components/pei/shared/accordion';
import { OtherAgencyService } from '@/components/student/registry/components/tab4';
import { ActionButton } from '@/components/common';
import Alert from '@/mixin/alert.mixin';
import generalService from '@/services/pei/general';
import store from '@/store/index';

export default {
  name: 'Tab4',
  mixins: [Alert],
  components: {
    SectionTitle,
    Accordion,
    OtherAgencyService,
    AccordionItem,
    ActionButton,
    FixedBottomSaveButton,
  },
  data() {
    return {
      previouslyAdministeredEvaluations: [],
      canEditTab4: store.getters.HasPermission('registry.editTab4'),
    };
  },
  computed: {
    ...mapState(['selectedStudentPreRegistry']),
    ...mapGetters({
      selectedStudent: 'SelectedStudent',
      selectedPreRegistry: 'getStudentPreRegistry',
    }),
    isAddEvaluationBtnDisabled(){
      const statuses = ['Registro', 'Evaluado'];
      return (this.isReadMode && !statuses.includes(this.studentStatus)) || !this.canEditTab4;
    },
    canAddEvaluation() {
      return !this.isAddEvaluationBtnDisabled
    },
    isReadMode() {
      return this.selectedStudentPreRegistry.isReadMode;
    },
    studentStatus() {
      return this.$store.getters.SelectedStudent.status;
    },
    isPreRegistred() {
      return this.studentStatus === 'Pre-Registro';
    },
    regStudentId() {
      return this.selectedPreRegistry.regStudentId;
    },
  },
  activated() {
    this.$store.commit('setSaveMethod', this.save);
    this.$store.commit('setResetOriginalDataMethod', this.discardChanges);
  },
  methods: {
    async GetPreviouslyAdministeredEvaluations() {
      let url =
        '/api/studentregistry/studentevaluations' +
        `?studentSieId=${store.getters.SelectedStudent.studentId}`;
      +`&regStudentId=${store.getters.SelectedStudent.regStudentId}`;
      let self = this;
      return await self
        .$ApiGet(url)
        .then((response) => {
          this.previouslyAdministeredEvaluations = response.data;
        })
        .catch((errm) => {
          self.ShowToast(errm.message, '', 'error');
        });
    },
    goToAddEvaluation() {
      this.$router.push({
        name: 'student-evaluation-history-add',
        params: {
          from: 'Regresar a la parte IV del Registro',
          headerTitle: 'Estudiante: Evaluaciones Administradas Previamente',
          toward: {
            name: 'registry',
            query: {
              tab: 'RegistryEvaluationAndServices',
              preRegistryId: this.regStudentId,
            },
          },
        },
      });
    },
    deleteEvaluation(evaluation) {
      let self = this;
      this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea eliminar la evaluación? ',
        'Si',
        'No'
      ).then(function(response) {
        if (response) {
          let url = `/api/studentevaluation/delete/${evaluation.studentEvaluationId}`;
          self
            .$ApiDelete(url)
            .then(() => {
              self.ShowToast(
                'Proceso exitoso.',
                'Los datos fueron guardados exitosamente.',
                'success'
              );
              let index = self.previouslyAdministeredEvaluations.indexOf(
                evaluation
              );
              self.previouslyAdministeredEvaluations.splice(index, 1);
            })
            .catch((err) => {
              self.ShowToast(err, '', 'error');
            });
        }
      });
    },
    downloadEvaluation(evaluacion) {
      let evaluationId = evaluacion.studentEvaluationId;
      let documents = evaluacion.eligibilityDocuments;
      documents.forEach((document) => {
        generalService
          .downloadStudentDocument(evaluationId, document.documentTypeId)
          .then((res) => {
            if (!res) {
              this.ShowToast('Este documento no esta disponible', '', 'error');
            }
          })
          .catch((err) => {
            this.ShowToast(err, '', 'error');
          });
      });
    },
    async save() {
      // here goes the save method for this tab
    },
    discardChanges() {
      // here goes the discard changes method for setting the data to the default values or value stored in db
      // this method is for being called when the user doesn't want the new changes to be applied when
      // leaving this tab.
    },
  },
  async mounted() {
    await this.GetPreviouslyAdministeredEvaluations();
  },
};
</script>

<style scoped lang="scss">
.header {
  font: Bold 16px/22px Lato;
  letter-spacing: 0;
  color: #ffffff;
  opacity: 1;
  background: #3f5b60 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  opacity: 1;
  margin-top: 25px;
}

.info-seguimiento {
  background: #fafbfa 0% 0% no-repeat padding-box;
  opacity: 1;
}

.col-actions {
  padding-right: 12px;
}

.custom-accordion-item {
  ::v-deep .card-header {
    height: unset !important;
  }
}
</style>
